import React, {useEffect} from 'react';

import DocumentHeader from '../../components/DocumentHeader';
import {StarIcon} from '../../components/svg';
import ActivityCard from './ActivityCard';
import Leaderboard from './Leaderboard';
import {useAppContext, useAnalytics} from '../../hooks';
import {KarmaValues} from '../../../../lib/utils';
import {getBrandName} from '../../components/Brand';

const KarmaPage = () => {
  const {currentUser} = useAppContext();
  const {tracker} = useAnalytics();

  useEffect(() => {
    tracker.karmaViewKarmaPage();
  }, []);

  return (
    <div className="bg-white min-h-screen">
      <DocumentHeader
        title="Karma"
        socialDescription={`Find out what Karma means on ${getBrandName()} and see where you rank`}
      />
      <div className="flex flex-col items-center mx-auto max-w-4xl py-8 px-3 sm:py-12 lg:px-0">
        <StarIcon className="h-32 w-32 text-yellow-400" />
        <h1 className="text-4xl text-center font-bold text-gray-700 mb-6">
          {currentUser?.karma
            ? `You've earned ${currentUser.karma.toLocaleString()} karma!`
            : 'What is karma?'}
        </h1>
        <p className="max-w-3xl text-gray-400 text-center font-medium mb-8">
          {`Karma is a rough measurement of your contributions to the ${getBrandName()} community.
          The better your contributions, the more votes and karma you’ll receive.`}
        </p>
        <div className="w-full grid grid-cols-1 gap-3 md:grid-cols-2 lg:gap-10">
          <Leaderboard className="mb-10" />
          <div className="mb-10">
            <h2 className="text-lg font-bold mb-4">How to earn karma</h2>
            {Object.values(KarmaValues).map((activity) => (
              <ActivityCard activity={activity} key={activity.id} />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default KarmaPage;
